// @ts-expect-error: implicitly has an 'any' type
import buildFormatLongFn from 'date-fns/locale/_lib/buildFormatLongFn';

const dateFormats = {
  full: "EEEE, d 'di' MMMM 'di' yyyy",
  long: "d 'di' MMMM 'di' yyyy",
  medium: "d 'di' MMM 'di' yyyy",
  short: 'd/MM/yyyy',
};

const timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm',
};

const dateTimeFormats = {
  full: "{{date}} 'na' {{time}}",
  long: "{{date}} 'na' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}',
};

export const formatLong: Locale['formatLong'] = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full',
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full',
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full',
  }),
};
